import React, { Fragment, useState, useEffect } from 'react';
import requestApiService from '../../services/requestApi.service';
import Common from '../Common';
import { aiPromptLibraryFields, ailibOptions, libraryHideFields } from './constants';
import { Col, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Button, Card, CardBody, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { handleAudioOperation, showToast, translateContent } from '../../Common/Appcommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import AIPromptLibModal from './AiPromptLibModal';
const AIPromptLibrary = (props) => {
    const [isOpenlibraryModal, setIsOpenlibraryModal] = useState(false);
    const [libraryData, setLibraryData] = useState({});
    const [audioStates,setAudioStates] = useState({});
    const [isUpdating,setIsUpdating] = useState(false);
    const [isAllowEdit,setIsAllowEdit] = useState(true);
    const [isUpdate,setIsUpdate] = useState(false);
    const [libLoading,setLibLoading] = useState(false);
    const [selectedRowData,setSelectedRowData] = useState({});
    const [deleteLoading,setDeleteLoading] = useState(false);
    useEffect(() => {
        fetchPrompt();
    }, []);

    const libraryContainer = () =>{
        return(
            <Fragment>
                <div className='account-pricing-container '>
                    <div className='pricing-header d-flex'>
                        <div className={'pricing-header-right'}>
                            <Button className='add-plan-btn theme-bg-g' onClick={e => {openCreatePrompt()}}><FontAwesomeIcon icon={faPlus} className='me-2'/>Create Prompt</Button>
                        </div>
                    </div>
                    {libraryCards()}
                    {isOpenlibraryModal && <AIPromptLibModal
                        onChange={""}
                        onSubmit={handleSubmit} 
                        fieldNames={"nameLabelMapper"}
                        libraryModalOpen = {isOpenlibraryModal}
                        handlelibraryModalOpen = {handleLibraryModal}
                        isLoading = {libLoading}
                        providerName = {"providerName"}
                        isAllowEdit = {isAllowEdit}
                        rowData = {selectedRowData}
                    />
                    }
                </div>
            </Fragment>
        );
    }

    const handlePlay = async (audioUrl, rowIndex, event) => {
        event.stopPropagation();
        Object.keys(audioStates).forEach((index) => {
            if (audioStates[index]?.isPlaying) {
                audioStates[index].audio.pause();
                audioStates[index].audio.currentTime = 0; // Reset playback to the start
                setAudioStates((prevAudioStates) => ({
                    ...prevAudioStates,
                    [index]: { isPlaying: false, audio: null },
                }));
            }
        });
        if(audioUrl === null){
            showToast("Audio url not found");
            return;
        }
        if (isUpdating) return;
        const newAudioState = await handleAudioOperation(audioUrl, audioStates[rowIndex]);
        setAudioStates((audioStates) => ({
            ...audioStates,
            [rowIndex]: newAudioState,
        }));
        setIsUpdating(false);
        if (newAudioState.audio) {
            newAudioState.audio.onended = () => {
                setAudioStates((audioStates) => ({
                    ...audioStates,
                    [rowIndex]: { isPlaying: false, audio: null },
                }));
            };
        }
    };

    const openCreatePrompt = () =>{
        setIsAllowEdit(true);
        setSelectedRowData({});
        handleLibraryModal();
    }
    const handleAgentOptionChange = (option, value,data) =>{
        setSelectedRowData(data);
        if(value == "view"){
            setIsAllowEdit(false);
            handleLibraryModal();
        }else if(value == "update"){
            setIsAllowEdit(true);
            setIsUpdate(true);
            handleLibraryModal();
        }else if(value == "delete"){
            deleteAiPromt(data);
        }
    }

    const handleLibraryModal = () => {
        setIsOpenlibraryModal(!isOpenlibraryModal)
    }

    const fetchPrompt = async () => {
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "GET_AI_PROMPT_LIBRARY",
            isOtherApiReq: true
        };

        try {
            const response = await requestApiService.processServerRequest(params);
            if (response.issuccess) {
                const data = response.data;
                setLibraryData(data);
            }
        }catch(error) {
            console.error("Error fetching voice list:", error);
        }
        
    }

    const handleSubmit = async (data) => {
        setLibLoading(true);
        let oprName = "create";
        if(isUpdate){
            oprName = "update";
        }
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "PROCESS_AI_PROMPT_LIBRARY",
            SUB_OPERATION : oprName,
            FORMINPUT : data,
            isOtherApiReq: true
        };

        try {
            const response = await requestApiService.processServerRequest(params);
            if (response.issuccess) {
                const data = response.data;
                fetchPrompt();
                handleLibraryModal();
            }
        }catch(error) {
            console.error("Error fetching voice list:", error);
        }
        setLibLoading(false);
    }

    const deleteAiPromt = async(data) =>{
        setDeleteLoading(true);
        const params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "DELETE_AI_PROMPT_LIBRARY",
            FORMINPUT : data,
            isOtherApiReq: true
        };

        try {
            const response = await requestApiService.processServerRequest(params);
            if (response.issuccess) {
                const data = response.data;
                fetchPrompt();

            }
        }catch(error) {
            console.error("Error fetching voice list:", error);
        }
        setDeleteLoading(false);
    }

    const showLibOptions = (data) =>{
        return(
            <>
                <UncontrolledDropdown>
                    <DropdownToggle className="agent-test-btn">
                        <i class="fi fi-rr-menu-dots-vertical mt-2 agent-option"></i>
                    </DropdownToggle>
                    <DropdownMenu className="agent-dropdown-lists dropdown-menu-right dropdown-menu-rounded">
                        {
                            ailibOptions && 
                            ailibOptions.map((option, index) => {
                                let label = option.label;
                                let value = option.value;
                                let menuicon = option.icon;
                                return (
                                    <DropdownItem 
                                        className="dropdown-list" 
                                        onClick={e => handleAgentOptionChange(option, value,data)}
                                    >
                                        {menuicon}
                                        <span>
                                            {label}
                                        </span>
                                    </DropdownItem>
                                )
                            })
                        }
                    </DropdownMenu>
                </UncontrolledDropdown>            
            </>
        )
    }
    const libraryCards = () =>{
        return(
            <Fragment>
                <div className='pricing-body m-3'>
                    <div className='plans-list mx-auto pb-4'>
                        <Row lg="12">
                        {libraryData && libraryData.length > 0 && libraryData.map((data, index) => {
                            let services = data["services"] ? data["services"].split(",") : [];
                            const isPlaying = audioStates[index]?.isPlaying;
                            return (
                                <Col md={4} key={index} className="mt-4">
                                    <Card className='card-br'>
                                        <CardBody className='pb-5 '>
                                            <div>
                                                <div className="d-flex mt-2">
                                                    <div>
                                                        <div className="agent-name-div">
                                                            {data["Agent_Name"]}
                                                        </div>
                                                        <div>
                                                            {data["category"]}
                                                        </div>
                                                    </div>
                                                    <div className="ms-auto d-flex pe-2">
                                                        <span onClick={(event) => handlePlay(data["voice_url"],index,event)} className="audio-play-button d-flex cursor-pointer">
                                                            {isPlaying ? (
                                                                <i className="icon-color fi fi-rr-pause"></i> // Pause icon
                                                            ) : (
                                                                <i className="icon-color le-form-row fi fi-rr-play"></i> // Play icon
                                                            )}
                                                        </span>    
                                                    </div>
                                                    <div className='pt-1'>
                                                        {showLibOptions(data)}
                                                    </div>
                                                </div>
                                                <div className="pt-4 d-flex flex-column">
                                                    <span className="pb-2">Perfect for</span>
                                                    <div className="d-flex flex-wrap gap-3">
                                                        {services && services.length > 0 && services.map((val, i) => (
                                                            <div key={i} className={`agent-badge`}>
                                                                {val.trim()}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            );
                        })}
                        </Row>
                    </div>
                </div>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Common
                title={"AI Prompt library"}
                titleContent={<span>AI Prompt library</span>}
                mainContent={
                    libraryContainer()
                }
                mainLoader = {deleteLoading}
            />
        </Fragment>
    );
};

export default AIPromptLibrary;
